import React, { useContext, useEffect, useState } from "react";
import logo from "../Assets/Vector Smart Object.png";
import { Link, useLocation } from "react-router-dom";
import { DataContext } from "../Context/Context";

const Navbar = () => {
  const { user, logout } = useContext(DataContext);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname; // gets current path

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = (window.scrollY / window.innerHeight) * 100;
      setScrolled(scrollPercent > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <div
      className={`fixed w-[100%] z-[9999] py-2 ${
        scrolled ? "bg-white shadow-lg" : "bg-transparent"
      } transition-all`}
    >
      <div className="container">
        <div className="navbar">
          <div className="flex-1">
            <Link className="text-xl cursor-pointer">
              <img
                src={logo}
                alt=""
                className={`${
                  !scrolled &&
                  !path.includes("/checkout") &&
                  !path.includes("/blog/") &&
                  !path.includes("/listing")
                    ? "brightness-200"
                    : ""
                } w-32`}
              />
            </Link>
          </div>
          <div className="flex-none">
            <ul className="menu menu-horizontal mb-0  items-center hidden md:hidden lg:flex font-thin">
              <li>
                <Link
                  to={"/about"}
                  className={`${
                    scrolled
                      ? "text-[#0008] hover:text-[#0005]  active:text-[#000] focus:text-[#000]"
                      : path.includes("/checkout") || path.includes("/listing")
                      ? "text-[#0007] hover:text-[#0007] active:text-[#0007] focus:text-[#0007]"
                      : "text-[#fff] hover:text-[#f5f5f5] active:text-[#f5f5f5] focus:text-[#f5f5f5]"
                  } `}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to={"/properties"}
                  className={`${
                    scrolled
                      ? "text-[#0008] hover:text-[#0005]  active:text-[#000] focus:text-[#000]"
                      : path.includes("/checkout") || path.includes("/listing")
                      ? "text-[#0007] hover:text-[#0007] active:text-[#0007] focus:text-[#0007]"
                      : "text-[#fff] hover:text-[#f5f5f5] active:text-[#f5f5f5] focus:text-[#f5f5f5]"
                  } `}
                >
                  Properties
                </Link>
              </li>
              <li>
                <Link
                  to={"/experiences"}
                  className={`${
                    scrolled
                      ? "text-[#0008] hover:text-[#0005]  active:text-[#000] focus:text-[#000]"
                      : path.includes("/checkout") || path.includes("/listing")
                      ? "text-[#0007] hover:text-[#0007] active:text-[#0007] focus:text-[#0007]"
                      : "text-[#fff] hover:text-[#f5f5f5] active:text-[#f5f5f5] focus:text-[#f5f5f5]"
                  } `}
                >
                  Experiences
                </Link>
              </li>
              <li>
                <Link
                  to={"/list-with-us"}
                  className={`${
                    scrolled
                      ? "text-[#0008] hover:text-[#0005]  active:text-[#000] focus:text-[#000]"
                      : path.includes("/checkout") || path.includes("/listing")
                      ? "text-[#0007] hover:text-[#0007] active:text-[#0007] focus:text-[#0007]"
                      : "text-[#fff] hover:text-[#f5f5f5] active:text-[#f5f5f5] focus:text-[#f5f5f5]"
                  } `}
                >
                  List With Us
                </Link>
              </li>
              <li>
                <Link
                  to={"/blog"}
                  className={`${
                    scrolled
                      ? "text-[#0008] hover:text-[#0005]  active:text-[#000] focus:text-[#000]"
                      : path.includes("/checkout") || path.includes("/listing")
                      ? "text-[#0007] hover:text-[#0007] active:text-[#0007] focus:text-[#0007]"
                      : "text-[#fff] hover:text-[#f5f5f5] active:text-[#f5f5f5] focus:text-[#f5f5f5]"
                  } `}
                >
                  Blogs
                </Link>
              </li>
              <li>
                <Link
                  to={"/contact"}
                  className={`${
                    scrolled
                      ? "text-[#0008] hover:text-[#0005]  active:text-[#000] focus:text-[#000]"
                      : path.includes("/checkout") || path.includes("/listing")
                      ? "text-[#0007] hover:text-[#0007] active:text-[#0007] focus:text-[#0007]"
                      : "text-[#fff] hover:text-[#f5f5f5] active:text-[#f5f5f5] focus:text-[#f5f5f5]"
                  } `}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
            <ul className="menu menu-horizontal mb-0  items-center lg:hidden flex">
              <li className="custom_li dropdown">
                <div
                  tabIndex={0}
                  role="button"
                  className="hamburger hover:bg-transparent focus:bg-transparent"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={32}
                    height={32}
                    className={`${
                      (scrolled && path.includes("/")) ||
                      path.includes("/listing") ||
                      path.includes("/blog/") ||
                      path.includes("/checkout")
                        ? "text-[#2b2b2b88]"
                        : "text-[#fff]"
                    }`}
                    fill={"none"}
                  >
                    <path
                      d="M4 5L20 5"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4 12L20 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4 19L20 19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {isOpen && (
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu bg-base-100 rounded-box z-[1] w-40 p-2 shadow top-16 right-0"
                  >
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        className="navigation_link font-thin py-[3px] text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                        to="/"
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        to="/about"
                        className="navigation_link font-thin py-[3px] text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                      >
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        to="/properties"
                        className="navigation_link font-thin py-[3px] text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                      >
                        Properties
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        to="/experiences"
                        className="navigation_link font-thin py-[3px] text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                      >
                        Experiences
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        to="/contact"
                        className="navigation_link font-thin py-[3px] text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                      >
                        Contact Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        to="/list-with-us"
                        className="navigation_link font-thin py-[3px] text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                      >
                        List With Us
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={handleLinkClick}
                        to="/blog"
                        className="navigation_link font-thin text-[16px] py-[3px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                      >
                        Blog
                      </Link>
                    </li>
                    {user ? (
                      <>
                        <li>
                          <Link
                            onClick={handleLinkClick}
                            to="/dashboard"
                            className="navigation_link lg:hidden md:hidden py-[3px] font-thin text-[16px] hover:no-underline text-[#74716d] hover:text-[#6c675b]"
                          >
                            Dashboard
                          </Link>
                        </li>
                        <li>
                          <span
                            onClick={() => {
                              handleLinkClick();
                              logout();
                            }}
                            className="text-[16px] py-[3px] font-thin text-[#74716d] flex items-center gap-2 hover:no-underline hover:text-red-500"
                          >
                            Logout
                          </span>
                        </li>
                      </>
                    ) : (
                      <></>
                    )}
                  </ul>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
